export default "__VITE_ASSET__CVSYUuS___"